module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/yswz1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fyswz1.png
// module id = vFGt
// module chunks = 93